module.exports = __webpack_public_path__ + "static/media/economy.2df484fc.png";